import { type FunctionComponent } from 'react';
import React, { useState } from 'react';

import { getImpersonation } from './impersonation';
import { stopImpersonation } from './impersonationControl';

// Always-on-screen reminder that the app is not showing the signed in user's own data.
// Rendered from AppSelector, so it is present in the TLB, OPS and technician apps alike.
const ImpersonationBanner: FunctionComponent = () => {
    const impersonation = getImpersonation();
    const [isStopping, setIsStopping] = useState(false);

    if (!impersonation) {
        return null;
    }

    const onStop = async () => {
        setIsStopping(true);
        try {
            await stopImpersonation();
        } catch (e) {
            console.error(e);
            setIsStopping(false);
            alert(`Impersonaci se nepodařilo ukončit: ${e instanceof Error ? e.message : String(e)}`);
        }
    };

    return (
        <>
            <div style={frameStyle} />
            <div style={pillStyle}>
                <span>
                    IMPERSONACE (read-only): <strong>{impersonation.targetLabel}</strong>
                </span>
                <button disabled={isStopping} style={buttonStyle} type="button" onClick={onStop}>
                    {isStopping ? 'Ukončuji…' : 'Ukončit'}
                </button>
            </div>
        </>
    );
};

const frameStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    border: '3px solid #c62828',
    pointerEvents: 'none',
    zIndex: 100000,
};

const pillStyle: React.CSSProperties = {
    position: 'fixed',
    right: 12,
    bottom: 12,
    zIndex: 100001,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '6px 10px',
    borderRadius: 20,
    background: '#c62828',
    color: '#fff',
    fontSize: 12,
    lineHeight: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.4)',
};

const buttonStyle: React.CSSProperties = {
    background: '#fff',
    color: '#c62828',
    border: 'none',
    borderRadius: 12,
    padding: '3px 10px',
    fontSize: 12,
    fontWeight: 700,
    cursor: 'pointer',
};

export default ImpersonationBanner;
